import EditFilled from '@ant-design/icons/lib/icons/EditFilled'
import Flex from 'antd/lib/flex'
import MarkdownRenderer from 'Components/common/MarkdownRenderer/MarkdownRenderer'

type UserContentPropsType = {
    prompt: string
    onClickEditContent: () => void
    isEditAllowed: boolean
}

export const UserContent = (props: UserContentPropsType) => {
    const { prompt, onClickEditContent, isEditAllowed } = props

    return (
        <div className={'conversation-user-turn' + (isEditAllowed ? ' editable' : '')}>
            <div className={'conversation-message'}>
                <MarkdownRenderer children={prompt} escapeBackslashses={true} />
            </div>
            {isEditAllowed && (
                <Flex className="edit-container" gap={5} onClick={onClickEditContent}>
                    <EditFilled />
                </Flex>
            )}
        </div>
    )
}
